/**
@format
@flow
*/
import * as React from 'react';
import PropTypes from 'prop-types';
import ViewportManager from './ViewportManager';

// /**
//  * This is the root class to manage a variety of things for applications utilizing this library.
//  * A user will implement this class as a Wrapper around their application once.
//  */

export type AppManagerProps = {
  children?: React.ChildrenArray<React$Node>
}

class AppManager extends React.Component<AppManagerProps> {
  componentDidMount() {
    ViewportManager.register();
  }

  componentWillUnmount() {
    ViewportManager.unregister();
  }

  render(): React.Node {
    const { children } = this.props;
    if (!children) {
      return null;
    }
    return children;
  }
}

AppManager.propTypes = {
  children: PropTypes.node,
};

export default AppManager;
